// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1kwo7","inputWrap":"CustomTip_inputWrap__1XUNP"};